import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export default function FullScreenDialog({
  open,
  onClose,
  children,
  title,
  refresh,
}) {
  return (
    <React.Fragment>
      <Dialog fullScreen open={open} onClose={onClose}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {title}
            </Typography>
            {/*<Button autoFocus color="inherit" onClick={handleClose}>*/}
            {/*  Ok*/}
            {/*</Button>*/}
          </Toolbar>
        </AppBar>
        {children}
      </Dialog>
    </React.Fragment>
  );
}
